import { PipeCarrier } from '@api/queries/inventory';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import DetailsInput from './DetailsInput';

interface Props extends WithTranslation {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  pipe?: PipeCarrier;
  trafficOut: boolean;
  isDisabled?: boolean;
}

const Pipe = ({ isDisabled, pipe, onChange, t }: Props) => {
  const { destinationAddress } = pipe || { destinationAddress: '' };

  return (
    <DetailsInput
      name="destinationAddress"
      label={t('entry.pipe.destination_address')}
      isDisabled={isDisabled}
      value={destinationAddress}
      onChange={onChange}
    />
  );
};

export default withTranslation()(Pipe);
